import React, { useContext, useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';

import expoHallAPI from '../api/expoHallAPI';
import { setColor, setBoxShadow } from '../styles/styles';

import {Socket,connectChat,disconnectChat} from '../api/expoHallSocket';

import ExhibitorContext from '../context/exhibitorContext';
import Navbar from '../components/globals/Navbar';
import { Context as UserContext } from '../context/UserContext';

import styled from 'styled-components';
import SliderCarousel from '../components/sliderCarousel/SliderCarousel';

import { Context as AttendantContext } from '../context/AttendantContext';
import { Context as SocketContext } from '../context/SocketContext';
import Countdown from 'react-countdown';
import { CustomNotification } from '../components/globals/NotificationAgreement';
import SliderPageRightPane from './SliderPageRightPane';
import LoadingPage from './LoadingPage';
import SiteData from '../config'

//timestamp logging
import getTimeLogged from '../utils/getTimeLogged';

const SliderPage = ({ className, loadChat }) => {
  const exhibitors = useContext(ExhibitorContext);
  const {
    state,
    state: { user },
    setUser,
  } = useContext(UserContext);
  const { state: { attendant } = {}, setAttendant } = useContext(
    AttendantContext
  );
  const {
    state: { categories,connection },
    setCategories,
  } = useContext(SocketContext);

  const [openNotification, setOpenNotification] = useState(false);
  const [notificationData, setNotificationData] = useState({});
  const [loadCategories, setLoadCategories] = useState(false);

  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
    handleAuthCheck();
  }, []);

  useEffect(() => {
    return () => {
      if (user) {
        disconnectChat(user,SiteData.generalChatId)
      }
    };
  }, [user]);

  useEffect(() => {
    if (user) {
      handleGetCategories();
      getNotification();
    }
  }, [connection,user]);

  useEffect(()=>{
    if(user && connection){
      connectChat(user,SiteData.generalChatId);
    }

  },[connection,user]);


  const handleAuthCheck = async () => {
    try {
      const token = localStorage.getItem('shrm-li-expo-user');
      expoHallAPI.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      const { data } = await expoHallAPI.get('/attendee/profile/');
      // console.log(data);
      if (data) {
        setUser(data);
      }
    } catch (error) {
      handleAuthCheckAttendant();
    }
  };

  const handleAuthCheckAttendant = async () => {
    try {
      const token = localStorage.getItem('shrm-li-expo-attendant');
      expoHallAPI.defaults.headers.common['Authorization'] = 'Bearer ' + token;
      const { data } = await expoHallAPI.get('/attendant/profile/');
      // console.log(data);
      if (data) {
        setUser(data);
        setAttendant(data);
      }
    } catch (error) {
      expoHallAPI.defaults.headers.common['Authorization'] = '';
      localStorage.removeItem('shrm-li-expo-user');
      localStorage.removeItem('shrm-li-expo-attendant');
      history.push('/login');
      setUser(undefined);
      setAttendant(undefined);
    }
  };

  const handleGetCategories = async () => {
    try {
      const { data } = await expoHallAPI.get('/api/categories/');
      setCategories(data);
      setLoadCategories(true);
    } catch (error) {
      console.log(error);
    }
  };

  const getNotification = async () => {
    try {
      const { data } = await expoHallAPI.get('/api/notifications/expo/');
      data.map((eachData) => {
        timeTriggerActions(eachData);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const timeTriggerNow = (data) => {
    const now = new Date();
    const TimeNow = Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      now.getUTCHours(),
      now.getUTCMinutes(),
      now.getUTCSeconds()
    );
    const EventTime = parseFloat(data.milliseconds);
    //time left for event
    let TimeLeftForEvent = EventTime - TimeNow;
    if (TimeLeftForEvent < 0) {
      TimeLeftForEvent += 86400000; // adds 1 day (runs everyday)
    }

    const eventDay = new Date(EventTime).getUTCDate();
    if (now.getUTCDate() === eventDay) {
      setTimeout(() => {
        auditoriumActions(data);
      }, TimeLeftForEvent);
    }
  };

  const timeTriggerPeriod = (data) => {
    const now = new Date();
    const EventTime = new Date(data.time);
    const EventEndTime = new Date(data.end_time);
    if (
      new Date(now.toUTCString()) > new Date(EventTime.toUTCString()) &&
      new Date(now.toUTCString()) < new Date(EventEndTime.toUTCString())
    ) {
      auditoriumActions(data);
    }
  };

  const timeTriggerActions = (data) => {
    switch (data.notif_type) {
      case 'NOW':
        timeTriggerNow(data);
        break;
      case 'PERIOD':
        timeTriggerPeriod(data);
        break;
      default:
      // code block
    }
  };

  const auditoriumActions = (data) => {
    const now = new Date(new Date().toUTCString());
    const EventTime = new Date(new Date(data.time).toUTCString());
    const differenceAfter = now.getTime() - EventTime.getTime();
    const differenceBefore = EventTime.getTime() - now.getTime();
    const minutes = Math.ceil(differenceBefore / 60000);

    getTimeLogged(data.id.toString());

    switch (data.id.toString()) {
      case '6':
        proceedToAuditorium();
        break;
      case '7':
        data.time = '';
        setNotificationData(data);
        setOpenNotification(true);
        //setAttendantNavbarBackLink('/');
        break;
      case '8':
        data.time = <Countdown date={Date.now() + 30000} />;
        setNotificationData(data);
        setOpenNotification(true);
        //setAttendantNavbarBackLink('/');
        break;
      case '9':
        proceedToAuditorium();
        break;
      case '10':
        proceedToAuditorium();
        break;
      case '14':
        data.message = data.message.split('. ').join('.\n');
        data.time = '';
        setNotificationData(data);
        setOpenNotification(true);
        //setAttendantNavbarBackLink('/');
        break;
      case '15':
        data.time = <Countdown date={Date.now() + 30000} />;
        setNotificationData(data);
        setOpenNotification(true);
        //setAttendantNavbarBackLink('/');
        break;
      case '16':
        expoHallAPI.defaults.headers.common['Authorization'] = '';
        localStorage.removeItem('shrm-li-expo-user');
        localStorage.removeItem('shrm-li-expo-attendant');
        history.push('/closing');
        setUser(undefined);
        setAttendant(undefined);
        break;
      case '17':
        expoHallAPI.defaults.headers.common['Authorization'] = '';
        localStorage.removeItem('shrm-li-expo-user');
        localStorage.removeItem('shrm-li-expo-attendant');
        history.push('/closing');
        setUser(undefined);
        setAttendant(undefined);
        break;
      default:
      // code block
    }
  };

  const proceedToAuditorium = () => {
    history.push('/auditorium');
  };
  if (!loadChat || !loadCategories) {
    return <LoadingPage />;
  } else {
    return (
      <div className={className}>
        <CustomNotification
          title={notificationData.title}
          description={notificationData.message}
          time={notificationData.time}
          open={openNotification}
          onCloseIconClick={(e) => {
            setOpenNotification(false);
          }}
        />
        <div className="leftPane">
          <Navbar />
          <ContainerDiv>
            {/* <p>NOTE: If tiles do not appear, please resize your browser window</p> */}
            {!!categories &&
              categories
                .sort((a, b) => a.id - b.id)
                .map((category) => (
                  <SliderCarousel key={category.id} category={category} />
                ))}
          </ContainerDiv>
        </div>
        <div className="rightPane">
          <h6>Event Discussion</h6>
          <SliderPageRightPane />
        </div>
      </div>
    );
  }
};

export default styled(SliderPage)`
  display: flex;
  position: relative;
  .leftPane {
    flex: 0.8;
    overflow-x: hidden;
    width: 80%;
  }
  .rightPane {
    flex: 0.2;

    height: 100vh;
    position: fixed;
    width: 20%;
    right: 0;
    background-color: white;
    h6 {
      padding-top: 5px;
      text-align: center;
      background-color: ${setColor.mainGrey};
      padding-bottom: 1rem;
    }
  }
`;

const ContainerDiv = styled.div`
  margin-right: 2rem;
  p {
    text-align: center;
  }
  margin-top: 7rem;
`;
